import { defaultHttpClient } from '../../httpClient';
import type {
  PostTermsAgreementVerifyRequest,
  PostTermsAgreementVerifyResponse,
} from './types';

/**
 * 소셜 로그인 기가입 게이트 — provider 토큰으로 "다른 채널로 이미 가입한 계정"이
 * 있는지 확인한다. JWT 발급 전에 호출하며, 응답의 registered_member가 있으면
 * 그 채널로 재로그인하도록 안내해야 한다.
 * - apple은 id_token, 그 외는 access_token으로 요청.
 */
export const postTermsAgreementVerify = ({
  provider,
  accessToken,
}: PostTermsAgreementVerifyRequest) => {
  return defaultHttpClient
    .request<PostTermsAgreementVerifyResponse>({
      method: 'POST',
      url: `/api/v2/auth/account-terms-agreement/${provider}/verify`,
      data:
        provider === 'apple'
          ? { id_token: accessToken }
          : { access_token: accessToken },
    })
    .then(result => result.data);
};
